import { v4 as uuid } from 'uuid';

function convertToOrderItem(newItem, menu, orderItemId) {
  const menuItem = menu.items.find(i => i.menuItemId === newItem.menuItemId);

  const pricePerItemCents = Math.round(menuItem.price * 100);
  let priceTotalCents = pricePerItemCents * newItem.quantity;
  const modifiers = [];

  // Iterate modifierGroups in menu order so cart display follows the order the
  // user sees in the item modal (e.g., Temperature, Toppings, Sides) rather than
  // the order the user happened to tap modifiers in.
  menuItem.modifierGroups.forEach((group) => {
    group.modifiers.forEach((modifier) => {
      const newItemModifier = newItem.modifiers.find(m => m.menuItemId === modifier.menuItemId);

      if (!newItemModifier) return;

      const modifierPricePerItemCents = Math.round(modifier.price * 100);
      const modifierPriceTotalCents = modifierPricePerItemCents * newItemModifier.quantity;
      const modifierPriceTotal = modifierPriceTotalCents / 100;
      priceTotalCents += modifierPriceTotalCents;

      modifiers.push({
        menuItemId: modifier.menuItemId,
        itemDescription: modifier.description,
        quantity: newItemModifier.quantity,
        priceTotal: modifierPriceTotal
      });
    });
  });

  const orderItem = {
    categoryId: newItem.categoryId,
    menuItemId: menuItem.menuItemId,
    isUpsell: newItem.isUpsell,
    itemDescription: menuItem.description,
    modifiers,
    orderItemId: orderItemId || uuid(),
    priceTotal: priceTotalCents / 100,
    quantity: newItem.quantity,
    specialInstructions: newItem.specialInstructions
  };

  return orderItem;
}



export default convertToOrderItem;
